
$(document).ready(function () {

	$('#selectstyle').selectize();
		$('#selectstyle2').selectize();

	$('#off_button_header').click(function(){
			$('#headerForm').slideToggle();
	});
	$('.popupForm__closed').click(function(){
			$('#headerForm').slideToggle();
	});

	$('#popupSteps').click(function(){
			$('#popupStepsForm').slideToggle();
	});

		$('#popupSteps2,[data-popup-steps-2]').click(function(){
				$('#popupStepsForm').slideToggle();
		});

	$('.popupSteps__close').click(function(){
			$('#popupStepsForm').slideToggle();
	});

	$('#contactFormButton').click(function(){
			$('#popupContact').slideToggle();
	});
	$('#popupContact__close').click(function(){
			$('#popupContact').slideToggle();
	});


	var input = document.querySelector('#qty');
	var btnminus = document.querySelector('.qtyminus');
	var btnplus = document.querySelector('.qtyplus');

	if (input !== undefined && btnminus !== undefined && btnplus !== undefined && input !== null && btnminus !== null && btnplus !== null) {

		var min = Number(input.getAttribute('min'));
		var max = Number(input.getAttribute('max'));
		var step = Number(input.getAttribute('step'));

		function qtyminus(e) {
			var current = Number(input.value);
			var newval = (current - step);
			if(newval < min) {
				newval = min;
			} else if(newval > max) {
				newval = max;
			}
			input.value = Number(newval);
			document.querySelector('#amongInput').value = Number(newval);
			e.preventDefault();
		}

		function qtyplus(e) {
			var current = Number(input.value);
			var newval = (current + step);
			if(newval > max) newval = max;
			input.value = Number(newval);
			document.querySelector('#amongInput').value = Number(newval);
			e.preventDefault();
		}

		btnminus.addEventListener('click', qtyminus);
		btnplus.addEventListener('click', qtyplus);

	} // End if test

	if ( $('.js-logoSlider').length ){
	  $('.js-logoSlider').slick({
	      arrows: true,
	      speed: 700,
	      autoplaySpeed: 7000,
	      dots: true,
	      infinite: true,
	      autoplay: false,
	      slidesToShow: 5,
	      slidesToScroll: 1,
	      responsive: [
	        {
	          breakpoint: 1200,
	          settings: {
	              slidesToShow: 4,
	              slidesToScroll: 4
	          }
	        },
	        {
	          breakpoint: 900,
	          adaptiveHeight: false,
	          settings: {
	              slidesToShow: 2,
	              slidesToScroll: 2
	          }
	        }
	        ,
	        {
	          breakpoint: 600,
	          adaptiveHeight: true,
	          settings: {
	              slidesToShow: 1,
	              slidesToScroll: 1
	          }
	        }
	      ]
	  });
	}


	$('.sidebarMenu').stick_in_parent({
	offset_top: 120
	});

	$('.search__icon').click(function(){
			$('.search__form').slideToggle();
	});

	$(".hover").mouseleave(
	  function () {
	    $(this).removeClass("hover");
	  }
	);


	AOS.init({
		   disable: 'mobile',
       offset: 200,
       duration: 600,
       delay: 100,});

  $(".js-up").on("click", function () {
    var body = $("html, body");
    body.stop().animate({
      scrollTop: 0
    }, 1500, 'swing');
  });
  $(window).on("scroll", function () {
    var scroll = $(window).scrollTop();
    if (scroll > 145) {
			AOS.refresh();

      $(".js-up").addClass("visible");
    } else {
      $(".js-up").removeClass("visible");
    }
  });

	$('.search__icon').click(function(){
			$('.search__form').slideToggle();
	});


	//language switcher
	$('.js-top__language').on('click',function(){
			$(this).toggleClass('top__language--open');
			return false;
	});

		//language switcher
	$('.js-top__language a:not(.active)').on('click',function(){
				$(this).addClass('active').siblings().removeClass('active');
				window.location.href = $(this).attr('href');
		});

$('.owl-dot').each(function(){
  $(this).children('span').text($(this).index()+1);
});
$(".sliderHome .owl-carousel").owlCarousel({
	 items:1,
	 margin:0,
	 stagePadding:0,
	 smartSpeed:950,
	 autoplay:false,
	 nav:true,
	 animateOut: 'animate__animated animate__fadeOutUp',
	 animateIn: 'animate__animated animate__fadeInUp',
	 navText : ["",""],
	 loop:true,
	 dots:true,
	 autoplayTimeout:7000,
	 autoplayHoverPause:true
});

$(".productSlider .owl-carousel").owlCarousel({
	 items:1,
	 margin:0,
	 stagePadding:0,
	 smartSpeed:450,
	 animateOut: 'fadeOut',
	 animateIn: 'fadeIn',
	 autoplay:true,
	 nav:true,
	 navText : ["",""],
	 loop:true,
	 dots:true,
	 autoplayTimeout:7000,
	 autoplayHoverPause:true
});


$(".partners .owl-carousel").owlCarousel({
	items:5,
	margin:0,
	stagePadding:0,
	smartSpeed:450,
	autoplay:true,
	nav:true,
	navText : ["",""],
	loop:true,
	dots:true,
	pagination:true,
	autoplayTimeout:5000,
	autoplayHoverPause:true,
	responsive : {
			0 : {
				items:1
			},
			768 : {
				items:2
			},
			990 : {
				items:3
			},
			1320: {
				items:5
			}
	 },
});

$(".slider--sub .owl-carousel").owlCarousel({
	items:1,
	margin:0,
	stagePadding:0,
	smartSpeed:450,
	animateOut: 'fadeOut',
	animateIn: 'fadeIn',
	autoplay:true,
	nav:true,
	navText : ["",""],
	loop:true,
	dots:true,
	autoplayTimeout:7000,
	autoplayHoverPause:true
});
	function callback(event) {
	$('.sliderContent .SliderSubtitle').hide();
	$('.sliderContent .SliderTitle').hide();
	$('.sliderContent .sliderButton').hide();
	$('.sliderContent .SliderDesc').hide();
	$('.sliderImage').hide();
	$('.sliderImage').addClass('zoomIn animated');
	$('.sliderContent .SliderSubtitle').addClass('fadeInDown animated');
	$('.sliderContent .SliderTitle').addClass('fadeInDown animated');
	$('.sliderContent .sliderButton').addClass('fadeInUp animated');
	$('.sliderContent .SliderDesc').addClass('fadeInUp animated');
	clearTimeout(myVar);
	var myVar = setTimeout(function() {
		$('.owl-item.active').find('.sliderContent .SliderTitle').show();
		$('.owl-item.active').find('.sliderContent .SliderDesc').show();
		$('.owl-item.active').find('.sliderContent .SliderSubtitle').show();
		$('.owl-item.active').find('.sliderContent .sliderButton').show();
		$('.owl-item.active').find('.sliderImage').show();
	}, 1000);
	}

	var didScroll = false,
    header = document.querySelector('.header'),
    body = document.querySelector('html, body'),
    ms = document.querySelector('body');

  function scrollTrue() {
    didScroll = true;
  }

  function isOnViewPoint() {
    if ((body.scrollTop || ms.scrollTop) >= 100) {
      header.classList.add('short');
    } else {
      header.classList.remove('short');
    }
  }

  window.addEventListener('scroll', scrollTrue);
  document.onscroll = scrollTrue();

  setInterval(function () {
    if (didScroll) {
      didScroll = false;
      isOnViewPoint();
    }
  });

// popupVideo

	PopUpHide();
	function PopUpHide(){
		$("#popupVideo").hide();
	}

	$(".popupOpen").on("click", function () {
		$("#popupVideo").show();
		$("#popupVideo").css("opacity" , "1");
	});
	$(".popupClose").on("click", function () {
		$("#popupVideo").hide();
	});
	$(".videoPopup").on("click", function () {
		$("#popupVideo").hide();
	});

	$(function(){
	  $('a[href^="#"]').on('click', function(event) {

	    event.preventDefault();

	    var sc = $(this).attr("href"),
	        dn = $(sc).offset().top;


	    $('html, body').animate({scrollTop: dn}, 1000);

	  });
	});








		var elem = document.querySelector('input[type="range"]');

		var rangeValue = function(){
		  var newValue = elem.value;
			var targetMoney = document.querySelector('.valueMoney');
			var course = document.querySelector('[data-course]').getAttribute('data-course');
			targetMoney.innerHTML = newValue;

			var a = 12;
			var b = 1.2;
			var c = 0.62;
			var d = 1000

			newValue = newValue*Math.ceil(parseFloat(course));
			var e = (((newValue / c) * a) * b) / d;
			var f = e.toFixed(2);
			// var g

			var target = document.querySelector('.value');
			target.innerHTML = f;
		}



		if(elem)
			elem.addEventListener("input", rangeValue);


		$('.calcRange').click(function(){
			$('.bannerHomeCalculate').hide();
			$('.bannerHomeCalcForm').show();
		});

		$('.popupForm__closed--formcalc').click(function(){
			$('.bannerHomeCalcForm').hide();
			$('.bannerHomeCalculate').show();
		});

		$("[data-landing-popupnext]").bind('click',function(){
			var step = parseInt($(this).closest("[data-landing-popupstep]").attr("data-landing-popupstep"));
			var tab = $("[data-landing-popupstep]:visible");

			var valid = true;
			$('input', tab).each(function(i, v){
				valid = $(v).valid() && valid;
			});

			if(!valid){
				return;
			}

			if(step<8){
				step++;
				$("[data-landing-popupstep]").hide();
				$("[data-landing-popupstep='"+step+"']").show();
			}
		});

		$("[data-landing-popupback]").bind('click',function(){
			var step = parseInt($(this).closest("[data-landing-popupstep]").attr("data-landing-popupstep"));
			if(step>1){
				step--;
				$("[data-landing-popupstep]").hide();
				$("[data-landing-popupstep='"+step+"']").show();
			}
		});

		$("#popupform").validate({
			errorPlacement: function(error, element) {
				if (element.attr("name") == "agree") {
					error.insertAfter(element.parent().find('span'));
				} else {
					error.insertAfter(element);
				}
			}
		});
});
